import axios from "axios";
import { Link } from 'react-router-dom';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function OpPayment() {
  const [opData, setOpData] = useState([]);
  const [amount, setAmount] = useState(0);
  const [balance, setBalance] = useState(0);
  const { appt_id } = useParams();


  useEffect(() => {
    try {
      axios.get(baseUrl + 'op-pay/' + appt_id + '/')
        .then(function (response) {
          setOpData(response.data);
          setAmount(response.data[0].fee);
          setBalance(0);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (opData.length > 0) {
      setAmount(opData[0].fee);
      setBalance(0);
    }
  }, [opData]);

  const handleAmountChange = (event) => {
    const newAmount = event.target.value;
    setAmount(newAmount);
  };

  const handlePaymentTypeChange = (event) => {
    const value = event.target.value;
    if (value === 'creditpay') {
      setAmount(0);
      setBalance(opData.length > 0 ? opData[0].fee : 0);
    } else {
      setAmount(opData.length > 0 ? opData[0].fee : 0);
      setBalance(0);
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const dbType = document.getElementById('dbType').value;
    axios.post(`${baseUrl}get_sale_op/`)
      .then(response => {
        const sale_op = response.data.value;
        const _formData = new FormData();
        _formData.append('fee', amount);
        _formData.append('paid', amount);
        _formData.append('balance', 0);
        _formData.append('invoice', sale_op);
        _formData.append('mode', dbType);
        _formData.append('cashier', userName);
        _formData.append('status', '2');
        axios.post(baseUrl + 'op-payment/' + appt_id + '/', _formData, {
          headers: {
            'content-type': 'multiple/form-data'
          }
        })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              Swal.fire({
                title: 'Payment Success and Invoice is Generated',
                icon: 'success',
                timer: 5000,
                showConfirmButton: false
              })
              setTimeout(() => {
                window.location.href = ('/op-invoice/' + sale_op + '/');
              }, 3000);
            }
          })
          .catch(error => {
            console.log(error);
            Swal.fire(
              'Error!',
              'Failed to add inv entry. Please try again later.',
              'error'
            );
          });
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to generate unique value. Please try again later.',
          'error'
        );
      });
  };

  return (
    <section className="container mt-4">
      <div className="row">
        <div className='col-md-9 col-12 mb-2'>
          <div className="row">
            <h3 className="text-center"> OP Payment</h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                <thead>
                  <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                    <th>Appointment Id</th>
                    <th>Patient Id</th>
                    <th>Patient Name</th>
                    <th>Addedby</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {opData.map((row, index) =>
                    <tr style={{ border: "1px solid", borderColor: "#2194d9" }} key={index}>
                      <td>{appt_id}</td>
                      <td>{row.pat.pat_id}</td>
                      <td>{row.pat.patient}</td>
                      <td>{row.addedby}</td>
                      <td>{row.fee}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <form>
                <label>Choose Payment Type</label>
                <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                  <option value="cash">Cash</option>
                  <option value="card">Card</option>
                  <option value="creditpay">Credit Payment</option>
                  <option value="UPI">UPI</option>
                </select>
                <div className="form-group mt-3" >
                  <label style={{ fontWeight: 'bold' }}>Amount: &nbsp;</label>
                  <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                    <input type="number" name="amount" id="amount" value={amount} onChange={handleAmountChange} />
                  </div>
                </div>

                <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OpPayment;
